import PageDataContext from "@core-ui/ContextServices/PageDataContext";
import { useDiffStore } from "@core-ui/stores/DiffStore/DiffStore.provider";
import { useIsRevision } from "@ext/git/actions/Revisions/logic/hooks/useIsRevision";
import { useIsRevisionCompare } from "@ext/git/actions/Revisions/logic/hooks/useIsRevisionCompare";
import { useDiffToggle } from "@ext/git/core/Diff/logic/hooks/useDiffToggle";
import { useIsDiffView } from "@ext/git/core/Diff/logic/hooks/useIsDiffView";
import t from "@ext/localization/locale/translate";
import { useIsStorageConnected } from "@ext/storage/logic/utils/useStorage";
import { GlassToolbarIcon, GlassToolbarToggleButton } from "@ui-kit/GlassToolbar";

export const ToolbarDiffToggle = () => {
	const isReadOnly = PageDataContext.value.conf.isReadOnly;
	const isDiffView = useIsDiffView();
	const isRevision = useIsRevision();
	const isRevisionCompare = useIsRevisionCompare();
	const toggleDiffMode = useDiffToggle();
	const diffEnabled = useDiffStore((state) => !!state?.diff);
	const isStorageConnected = useIsStorageConnected();

	if (!isStorageConnected) return null;

	return (
		<GlassToolbarToggleButton
			active={diffEnabled}
			data-testid="tb-diff-toggler"
			disabled={(!isRevision && !isDiffView && isReadOnly) || isRevisionCompare}
			onClick={toggleDiffMode}
			tooltipText={t("editor.diff")}
		>
			<GlassToolbarIcon icon="diff" />
		</GlassToolbarToggleButton>
	);
};
